<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <MessageNotification />

    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view>
      </router-view>
    </transition>
  </component>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'

// Layouts
import useDynamicVh from '@core/utils/useDynamicVh'
import MessageNotification from '@core/components/dialogs/MessageNotification'
import { onMounted } from '@vue/composition-api/dist/vue-composition-api'
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'
import store from '@/store'

// Dynamic vh

export default {
  components: {
    MessageNotification,
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    useDynamicVh()

    const refreshData = data => {
      store.dispatch('notification/refreshNotificationsList', { page: 1, field: store.state.notification.field })
      switch (data.model) {
        case 'App\\Models\\Payment':
          store.state.payment.filterValidity.refresh++
          store.dispatch('payment/newPaymentEvent', data.id)
          break
        case 'App\\Models\\Role':
          store.commit('user/INCREMENT_REFRESH_MENU_COUNT')
          break
        case 'App\\Models\\Recovery':
          store.dispatch('recovery/newRecoveryEvent', data.id)
          break
        case 'App\\Models\\User':
          store.commit('user/INCREMENT_REFRESH_MEMBER_COUNT')
          break
        case 'App\\Models\\Road':
          store.dispatch('road/newRoadEvent', data.id)
          break
        default:
          console.log(data.model)
      }
    }

    onMounted(() => {
      const channel = new window.BroadcastChannel('notification')
      channel.addEventListener('message', event => {
        console.log(event)
        refreshData(event.data.data)
      })
    })

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
}
</script>
